import { lazy } from 'react'

const OccupationsComponent = lazy(async () => {
  const { Occupations } = await import(/* webpackChunkName: "occupations" */ './index')

  return {
    default: Occupations
  }
})
const routes = [
  {
    path: '/profile',
    render(props) {
      return <OccupationsComponent {...props} />
    }
  }
]

export { routes }
